module.exports = __webpack_public_path__ + "img/Frame.8ce026c4.svg";